import * as React from 'react'
import { Button, Form } from 'react-bootstrap'
import InputDatePicker from '../../../../../components/InputDatePicker'
import NumberFormatValidate from '../../../../../components/NumberFormatValidate'

import { VariableT, VariablesT, ListOptionsEstimate } from '../../../../../types/Company'
import * as _ from "lodash";
import { InvoiceLineItemT } from '../../../../../types/Job'



interface InvoiceLineItemProps {
    companyVariables: VariablesT
    lineItem: InvoiceLineItemT
    index: number
    updateLineItem(key: string, value: any, index: number): void
    removeLineItem(index: number): void
}

const InvoiceLineItem: React.FunctionComponent<InvoiceLineItemProps> = ({ companyVariables, lineItem, index, updateLineItem, removeLineItem }): JSX.Element => {

    const reflectorLabel = (variable: VariableT, isRate: boolean = true) => {
        let strLable = isRate ? variable.rateLabel : variable.unitsLabel
        // search <key> if exists in rateLabel or unitsLabel    
        const regex = /[<][a-z-A-Z]+[>]/g;
        let match = regex.exec(strLable)
        if (_.isArray(match) && match[0]) {
            let strMatch = String(match[0]).replace('<', '').replace('>', '');
            if (companyVariables[strMatch]) {
                // replace value for  related key by regex           
                return strLable.replace(regex, companyVariables[strMatch].value)
            }
        }
        return isRate ? variable.rateLabel : variable.unitsLabel;
    }

    //  renderLabel
    const renderLabel = (item: string, isRate: boolean = true): string => {
        if (companyVariables[item]) {
            return `, ${reflectorLabel(companyVariables[item], isRate)}`
        }
        return '';
    }

    const ItemsOptions = (): Array<JSX.Element> => {
        return ListOptionsEstimate.map((li, index) => {
            return <option value={li} key={index}>{companyVariables[li].verboseName}</option>
        })
    }

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px' }}>
            <div>
                <Form.Label>Date</Form.Label>
                <InputDatePicker
                    id={`estimate-date-${index}`}
                    className="input-material"
                    style={{ width: '100%' }}
                    selectedDate={`${lineItem.lineItemDate ? lineItem.lineItemDate : ""}`}
                    onChangeDate={(val) => {
                        updateLineItem('lineItemDate', val, index)

                    }}
                    onChange={(val) => {
                        // updateLineItem('lineItemDate', val, index)

                    }}
                    dateFormat="MM/dd/yyyy"
                    placeholder=""
                />
            </div>
            <div>
                <Form.Label>Item</Form.Label>
                <Form.Control
                    as='select'
                    className='input-material'
                    onChange={(event: any): void => { updateLineItem('item', event.target.value, index) }}
                    value={`${lineItem.item}`}>
                    {ItemsOptions()}
                </Form.Control>
            </div>
            <div>
                <Form.Label>Rate{renderLabel(lineItem.item, true)}</Form.Label>
                <NumberFormatValidate
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${lineItem.rate}`}
                    value={`${lineItem.rate}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != lineItem.rate) {
                            updateLineItem('rate', floatValue, index)
                        }
                    }}

                    // prefix={'$'}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    mask="_" />
            </div>
            <div>
                <Form.Label>Units{renderLabel(lineItem.item, false)}</Form.Label>
                <NumberFormatValidate
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${lineItem.units}`}
                    value={`${lineItem.units}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != lineItem.units) {
                            updateLineItem('units', floatValue, index)
                        }
                    }}
                    mask="_"
                    fixedDecimalScale={true}
                    decimalScale={2}
                />
            </div>
            <div>
                <Form.Label>Total, $</Form.Label>
                <Form.Control
                    className='input-material'
                    disabled
                    value={`${parseFloat(`${lineItem.total}`).toFixed(2)}`} />
            </div>
            <div style={{ cursor: "pointer" }} onClick={(): void => { removeLineItem(index) }}>
                x
            </div>
        </div>

    )
}

export default InvoiceLineItem